<template>
  <div class="banner_container">
    <el-carousel
      ref="myCarousel"
      :direction="direction"
      :indicator-position="indicatorPosition"
      :loop="loop"
      :height="height"
      :autoplay="autoplay"
      :interval="interval"
      @change="handerChange"
    >
      <el-carousel-item v-for="(item, index) in lists" :key="index">
        <!--  @click="openUrl(item)" -->
        <img class="c_img" :src="item.picUrl" alt="轮播图" />
        <div class="carouselBody">
          <div
            class="title"
            v-scroll-animate="{
              animation: 'fadeInDown',
              observerOnce: false,
              duration: 600,
              delay: 200,
            }"
          >
            <img
              class="icon"
              v-if="item.icon"
              :src="item.icon"
              alt=""
              srcset=""
            />
            {{ item.title || "" }}
          </div>
          <div
            class="subTitle text-wrap"
            v-scroll-animate="{
              animation: 'fadeInDown',
              observerOnce: false,
              duration: 500,
              delay: 400,
            }"
          >
            {{ item.subTitle || "" }}
          </div>
          <div
            class="stepBox"
            v-if="routePath.indexOf('digital') > -1"
            v-scroll-animate="{
              animation: 'fadeInDown',
              observerOnce: false,
              duration: 500,
              delay: 400,
            }"
          >
            <div
              class="step"
              v-for="(item, index) in steps"
              :key="item.id"
              :class="sliderIndex === index ? 'active' : ''"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <ul
      class="trigger-box"
      v-scroll-animate="{
        animation: 'fadeInLeft',
        observerOnce: false,
        duration: 600,
        delay: 200,
      }"
    >
      <li
        class="trigger-item"
        :class="sliderIndex === index ? 'active' : ''"
        v-for="(item, index) in lists"
        :key="index"
        @click="goTo(index)"
      >
        <div class="trigger-label">
          <span v-show="sliderIndex === index">
            {{ index < 10 ? "0" + (index + 1) : index + 1 }}
          </span>
        </div>
        <div class="line"></div>
      </li>
    </ul>
    <div
      v-if="isShowMore"
      class="learnMore"
      @click="openUrl(lists[sliderIndex])"
      v-scroll-animate="{
        animation: 'fadeInUp',
        observerOnce: false,
        duration: 500,
        delay: 400,
      }"
    >
      了解更多 >
    </div>
  </div>
</template>

<script>
export default {
  name: "VerticalBanner",
  props: {
    height: {
      type: String,
      default: () => {
        return "500px";
      },
    },
    // 指示器的位置
    indicatorPosition: {
      type: String,
      default: () => {
        return "outside"; // none
      },
    },
    // 方向
    direction: {
      type: String,
      default: () => {
        return "vertical"; // horizontal
      },
    },
    // 是否循环显示
    loop: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    // 是否自动播放
    autoplay: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    // 间隔时间
    interval: {
      type: Number,
      default: () => {
        return 10000;
      },
    },
    // 查看更多
    isShowMore: {
      type: Boolean,
      default: () => {
        return false;
      },
    },

    lists: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  components: {},
  data() {
    return {
      sliderIndex: 0,
      routePath: "",
      steps: [
        { id: "step_1", title: "STEP1 方案比选" },
        { id: "step_2", title: "STEP2 方案设计" },
        { id: "step_3", title: "STEP3 驾驶模拟验证" },
        { id: "step_4", title: "STEP4 方案汇报" },
      ],
    };
  },
  computed: {},
  created() {
    console.log("this.lists--", this.lists);
    this.routePath = this.$route.path;
  },
  mounted() {},
  methods: {
    openUrl(item) {
      if (item.bannerLink) {
        this.$uniFun.openInCurrentTab(item.bannerLink);
      }
    },
    handerChange(index) {
      console.log("handerChange", index);
      this.sliderIndex = index;
    },
    goTo(index) {
      this.$refs.myCarousel.setActiveItem(index);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.banner_container {
  background: #232323;
  position: relative;
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  .c_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .carouselBody {
    width: 1100px;
    position: absolute;
    top: 80px;
    left: 440px;
    color: #ffffff;
    .title {
      font-size: 28px;
      line-height: 48px;
      font-weight: 700;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 40px;
      .icon {
        height: 40px;
        margin-right: 12px;
      }
    }
    .subTitle {
      font-weight: 600;
      font-size: 32px;
      line-height: 48px;
      text-align: left;
    }
    .stepBox {
      margin-top: 25px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .step {
        padding: 10px 12px;
        border: 1px solid #ffffff;
        border-radius: 20px;
        font-size: 12px;
        line-height: 18px;
        opacity: 0.6;
        margin-right: 68px;
        position: relative;
        &.active {
          font-weight: bold;
          opacity: 1;
        }
        &::after {
          content: "";
          display: inline-block;
          width: 44px;
          height: 1px;
          background-color: #ffffff;
          opacity: 0.6;
          position: absolute;
          top: 50%;
          right: -56px;
        }
        &:last-child {
          &::after {
            display: none;
          }
        }
      }
    }
  }

  .trigger-box {
    position: absolute;
    top: 80px;
    left: 250px;
    width: 120px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    z-index: 10;
    .trigger-item {
      // flex: 1;
      // margin-right: 50px;
      // min-width: 224px;
      cursor: pointer;
      text-align: right;
      margin-bottom: 61px;
      &:last-child {
        margin-bottom: 0;
      }
      .line {
        display: block;
        width: 60px;
        height: 4px;
        margin-bottom: 16px;
        background-color: #fff;
        vertical-align: middle;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      .trigger-label {
        height: 32px;
        font-weight: 500;
        font-size: 32px;
        color: #ffffff;
        line-height: 32px;
        text-align: right;
        margin-bottom: 12px;
      }
      &.active {
        .line {
          width: 100%;
          background-color: #0035fb;
        }
      }
    }
  }
  .learnMore {
    position: absolute;
    bottom: 180px;
    left: 440px;
    width: 128px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #0035fb;
    border-radius: 20px;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    cursor: pointer;
    z-index: 10;
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
